import "./welcome_modal.scss";

import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@components/ui/dialog";
import { PrimaryButton } from "@sprout/buttons";
import ActivityIcon from "@sprout/icons/activity";
import CandidateIcon from "@sprout/icons/candidate";
import BriefcaseIcon from "@sprout/icons/briefcase";
import useTranslation from "@hooks/use_translation";
import useDevice from "@hooks/use_device";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

const HIGHLIGHTS = [
  { key: "track", Icon: ActivityIcon },
  { key: "matched", Icon: CandidateIcon },
  { key: "explore", Icon: BriefcaseIcon },
] as const;

const WelcomeModal = ({ open, onOpenChange }: Props) => {
  const { t } = useTranslation("onboarding", { keyPrefix: "welcomeModal" });
  const { isMobile } = useDevice();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent hideClose={false} className="welcome-modal block gap-0 p-0 sm:max-w-[480px]">
        <div className="welcome-modal__body">
          <DialogTitle>
            <h2 className="welcome-modal__title">{t("title")}</h2>
          </DialogTitle>
          <DialogDescription>
            <p className="welcome-modal__subtitle">{t("subtitle")}</p>
          </DialogDescription>

          <ul className="welcome-modal__list">
            {HIGHLIGHTS.map(({ key, Icon }) => (
              <li key={key} className="welcome-modal__item">
                <span className="welcome-modal__icon" aria-hidden="true">
                  <Icon size="md" />
                </span>
                <div className="welcome-modal__item-text">
                  <span className="welcome-modal__item-title">{t(`${key}.title`)}</span>
                  <span className="welcome-modal__item-body">{t(`${key}.body`)}</span>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="welcome-modal__footer">
          <PrimaryButton size={isMobile ? "medium" : "large"} onClick={() => onOpenChange(false)}>
            {t("cta")}
          </PrimaryButton>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default WelcomeModal;
